/* dialog:
 *
 * handle plugins the simplest of ways
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(doc).on("keydown", function (ev) {
    if (ev.keyCode === 27)
      // ESCAPE
      win.location.hash = "";
  });

  $(doc).on("click touchstart", ".dialog-mask", function () {
    win.location.hash = "";
  });

  $(doc).on("click touchstart", ".dialog-box", function (ev) {
    ev.stopPropagation();
    return true;
  });
})(jQuery, window, document);
